<div class="attachment_wrapper">
  <mat-menu #attachment_menu="matMenu" xPosition="before">
    <ng-container *ngIf="attachments.length">
      <a
        *ngFor="let attachment of attachments"
        [href]="attachment.url"
        class="message flex-row"
        download
        mat-menu-item
        title="{{ attachment.name }}"
      >
        {{ attachment.name }}
      </a>
    </ng-container>
    <ng-container *ngIf="!attachments.length">
      <a
        *ngIf="currentDocument.linkType === LinkTypeEnumeration.DOWNLOAD"
        [href]="linkUrl"
        class="message flex-row"
        download
        mat-menu-item
        title="{{ currentDocument.linkText }}"
      >
        {{ currentDocument.linkText }}
      </a>
      <a
        *ngIf="currentDocument.linkType === LinkTypeEnumeration.NEW_PAGE || currentDocument.linkType === LinkTypeEnumeration.REDIRECTION"
        [href]="currentDocument.link"
        class="message flex-row"
        target="_blank"
        mat-menu-item
        title="{{ currentDocument.linkText }}"
      >
        {{ currentDocument.linkText }}
      </a>
    </ng-container>
  </mat-menu>

  <button [matMenuTriggerFor]="attachment_menu" class="attachment_icon" (click)="$event.preventDefault(); $event.stopPropagation()">
    <span class="nodisplay">{{ 'commons:attachment.display' | translate }}</span>

    <span
      class="attachment_inner"
      [attr.aria-hidden]="true"
      *ngIf="currentDocument.linkType === LinkTypeEnumeration.DOWNLOAD || attachments.length"
      title="{{ 'commons:attachment.display' | translate }}"
    ></span>
    <mat-icon
      *ngIf="currentDocument.linkType === LinkTypeEnumeration.NEW_PAGE || currentDocument.linkType === LinkTypeEnumeration.REDIRECTION"
      class="link"
      >link</mat-icon
    >
  </button>
</div>
